// extracted by mini-css-extract-plugin
module.exports = {"whiteBackground":"templates--white-background--hD7LP"};